module.exports = __webpack_public_path__ + "img/logo-shuanglu02.114cf537.png";